import label from './bar.data.label'
import itemStyle from './bar.data.itemStyle'
import emphasis from './bar.data.emphasis'
import tooltip from './bar.data.tooltip'

export default {
  name: "data",
  nickname: "数据",
  desc: "系列中的数据内容数组。数组项通常为具体的数据项。",
  type: "array",
  props: {
    name: {
      name: "name",
      nickname: "名称",
      desc: "数据项名称。",
    },
    value: {
      name: "value",
      nickname: "值",
      desc: "单个数据项的数值。",
      type: "pureValue",
    },
    label,
    itemStyle,
    emphasis,
    tooltip,
  },
}
